document
	.querySelectorAll(".js-ga-universal-form")
	.forEach((formElement) => {
		const companyNameWrapper = formElement.querySelector(".js-company-name");

		formElement
			.querySelectorAll('input[name="reason"]')
			.forEach((reasonElement) => {
				reasonElement.addEventListener("change", () => {
					companyNameWrapper.classList.add("hidden");

					if (reasonElement.value === "enterprise") {
						companyNameWrapper.classList.remove("hidden");
					}
				});
			});
	});

(function () {
	document
	.querySelectorAll(".js-ga-universal-form")
	.forEach((formElement) => {
		const companyNameWrapper = formElement.querySelector(".js-company-name");

		formElement
			.querySelectorAll('input[name="reason"]')
			.forEach((reasonElement) => {
				reasonElement.addEventListener("change", () => {
					companyNameWrapper.classList.add("hidden");

					if (reasonElement.value === "enterprise") {
						companyNameWrapper.classList.remove("hidden");
					}
				});
			});

		formElement.addEventListener("submit", (event) => {
			event.preventDefault();

			const formData = new FormData(formElement);
			const values = Object.fromEntries(formData.entries());

			const hasErrors = validateForm(formElement, values);
			if (hasErrors) {
				return;
			}

			submitForm(formElement, values);
		});
	});

	function validateForm(form, values) {
		let hasError = false;
		for (const field of ["full_name", "email", "reason", "company_name", "canspam"]) {
			const inputs = form.querySelectorAll(`[name="${field}"]`);
			const input = inputs[0];
			if (!input) {
				continue;
			}

			const group = input.closest(".js-form-group");
			if (!group) {
				continue;
			}

			const errorElements = group.querySelectorAll(".js-form-error");
			const errorElement = errorElements[errorElements.length - 1];
			const value = values[field];
			const label = group
				.querySelector("label")
				.textContent
				.replace('*', '')
				.trim();

			if (!group.checkVisibility()) {
				continue;
			}

			if (value && value.length > 0) {
				errorElement.textContent = "";

				for (const i of inputs) {
					i.classList.remove("border-crimson");
				}
			}
			else {
				errorElement.textContent = `${label} is required.`;
				hasError = true;

				for (const i of inputs) {
					i.classList.add("border-crimson");
				}
			}

			if (field === "email" && value && value.length > 0) {
				const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
				if (emailRegex.test(value)) {
					errorElement.textContent = "";
					input.classList.remove("border-crimson");
				}
				else {
					errorElement.textContent = `${label} is not the correct format. Please enter a valid email address.`;
					input.classList.add("border-crimson");
					hasError = true;
				}
			}

			if (field === "canspam" && value && value.length > 0) {
				if (value === "true") {
					errorElement.textContent = "";
					input.classList.remove("border-crimson");
				}
				else {
					errorElement.textContent = `You must agree to receive marketing communications to continue.`;
					input.classList.add("border-crimson");
					hasError = true;
				}
			}
		}

		let phoneNumberHasError = false;
		const input = form.querySelector(`[name="phone_number"]`);
		const group = input.closest(".js-form-group-telephone");
		const errorElement = group.querySelector(".js-form-error");
		const value = values["phone_number"];

		input.classList.remove("border-crimson");
		if (!phoneNumberHasError) {
			errorElement.textContent = "";
		}

		if (!value) {
			errorElement.textContent = "Phone number is required.";
			input.classList.add("border-crimson");
			phoneNumberHasError = true;
			hasError = true;
		}

		const isValudNumber = input.getAttribute("data-valid") === "true";
		if (value && !isValudNumber) {
			errorElement.textContent = "Phone number is not valid.";
			input.classList.add("border-crimson");
			phoneNumberHasError = true;
			hasError = true;
		}

		return hasError;
	}

	function submitForm(form, values) {
		const method = form.getAttribute("method");
		const action = form.getAttribute("action");
		const formError = form.querySelector(".js-global-form-error");
		const loading = form.parentNode.querySelector(".js-form-loading");

		loading.classList.remove("hidden");

		fetch(`${action}`, {
			method,
			body: JSON.stringify(values),
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json'
			}
		})
		.then(function (response) {
			return response.json();
		})
		.then(function (data) {
			const { success, code } = data;

			loading.classList.add("hidden");

			if (!success) {
				formError.textContent = `An unexpected error occurred. Please try again.`;
				return;
			}

			form.classList.add("hidden");
			form.parentNode.querySelector(".js-form-success").classList.remove("hidden");
		});
	}
})();
